var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17659_48745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17659_48745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7997 20.0005H17.1997C17.3997 20.0005 17.5719 19.9172 17.7163 19.7505C17.8608 19.5839 17.9108 19.4005 17.8663 19.2005L17.233 15.7005C17.6775 15.4783 18.0275 15.1561 18.283 14.7339C18.5386 14.3116 18.6663 13.845 18.6663 13.3339C18.6663 12.6005 18.4052 11.9727 17.883 11.4505C17.3608 10.9283 16.733 10.6672 15.9997 10.6672C15.2663 10.6672 14.6386 10.9283 14.1163 11.4505C13.5941 11.9727 13.333 12.6005 13.333 13.3339C13.333 13.845 13.4608 14.3116 13.7163 14.7339C13.9719 15.1561 14.3219 15.4783 14.7663 15.7005L14.133 19.2005C14.0886 19.4005 14.1386 19.5839 14.283 19.7505C14.4275 19.9172 14.5997 20.0005 14.7997 20.0005ZM15.9997 29.2005C15.8441 29.2005 15.6997 29.1894 15.5663 29.1672C15.433 29.145 15.2997 29.1116 15.1663 29.0672C12.1663 28.0672 9.77745 26.2172 7.99967 23.5172C6.2219 20.8172 5.33301 17.9116 5.33301 14.8005V8.50052C5.33301 7.94497 5.49412 7.44497 5.81634 7.00052C6.13856 6.55608 6.55523 6.23385 7.06634 6.03385L15.0663 3.03385C15.3775 2.92274 15.6886 2.86719 15.9997 2.86719C16.3108 2.86719 16.6219 2.92274 16.933 3.03385L24.933 6.03385C25.4441 6.23385 25.8608 6.55608 26.183 7.00052C26.5052 7.44497 26.6663 7.94497 26.6663 8.50052V14.8005C26.6663 17.9116 25.7775 20.8172 23.9997 23.5172C22.2219 26.2172 19.833 28.0672 16.833 29.0672C16.6997 29.1116 16.5663 29.145 16.433 29.1672C16.2997 29.1894 16.1552 29.2005 15.9997 29.2005ZM15.9997 26.5339C18.3108 25.8005 20.2219 24.3339 21.733 22.1339C23.2441 19.9339 23.9997 17.4894 23.9997 14.8005V8.50052L15.9997 5.50052L7.99967 8.50052V14.8005C7.99967 17.4894 8.75523 19.9339 10.2663 22.1339C11.7775 24.3339 13.6886 25.8005 15.9997 26.5339Z",
    fill: "#2D2D2D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.91c5cfee494e72acd816925672379f3e.svg";
export { ForwardRef as ReactComponent };